import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import OverflowAwareTooltip from "app/static/frontend/profiles-new/components/OverflowAwareTooltip"

export const DataItemTooltipWrapper = ({ children, renderIcon }) => (
    <div className="subtitle-container">
        {children}
        {renderIcon && <i className="fa fa-external-link right-icon" />}
    </div>
)

DataItemTooltipWrapper.propTypes = {
    children: PropTypes.element,
    renderIcon: PropTypes.func,
}

export const DataItem = ({ title, subtitle, onClick, isLink, extraSubtitleClass, dlcWidth }) => (
    <div
        className={classNames(
            { dataItemTable: !dlcWidth },
            { "dataItemTable-dlc": dlcWidth },
            { pointer: !!onClick || !!isLink },
        )}
    >
        <OverflowAwareTooltip
            label={title}
            wrapperComponentClass="data-title"
            labelClass="data-title-text"
            labelComponent="div"
        />
        <OverflowAwareTooltip
            label={subtitle}
            wrapperComponent={DataItemTooltipWrapper}
            labelClass={`data-subtitle ${extraSubtitleClass}`}
            renderIcon={onClick || isLink}
            tooltipStyle={{ marginTop: "20px" }}
        />
    </div>
)

DataItem.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    onClick: PropTypes.func,
    isLink: PropTypes.bool,
    tooltipText: PropTypes.string,
    extraSubtitleClass: PropTypes.string,
    dlcWidth: PropTypes.number,
}

export default DataItem
